import {
  Typography, Box,
} from '@mui/material';
import {
  createTheme,
  responsiveFontSizes,
  ThemeProvider,
} from '@mui/material/styles';
import i18n from '../common/i18n';
import FormCancelCredit from '../common/formCancelCredit';
import '../../assests/css/cancelCreditStyle.css';
import HeaderTags from '../common/HeaderTags';
import SimpleBanner from '../common/SimpleBanner';

let theme = createTheme();
theme = responsiveFontSizes(theme);

const CancelCredit = () => (
  <>
    <HeaderTags title={i18n.metaTitleCancel} content={i18n.metaDescriptionCancel} metaContent="noindex, follow" />
    <ThemeProvider theme={theme}>
      <Box>
        <SimpleBanner title={i18n.cancelTitle} />
      </Box>
      <Box sx={{ paddingTop: '30px', paddingBottom: '30px' }}>
        <Typography variant="h3" fontWeight={800} className="lettersGrey">{i18n.cancelTitleBody}</Typography>
      </Box>
      <FormCancelCredit />
    </ThemeProvider>
  </>
);

export default CancelCredit;
